/**
 * Route guard: send a signed-in user away from a page their role cannot use.
 *
 * The redirect goes to the role's own landing page rather than showing a
 * "forbidden" screen, because the only way to arrive here is a stale bookmark
 * or a typed URL — the menu never offers these links. Users with no role at
 * all go to /no-access, which explains what to ask an administrator for.
 */
import React from "react";
import { Navigate } from "react-router-dom";

import { useRoles } from "./access";

interface RequireRoleProps {
  /** The route pattern exactly as written in App.tsx. */
  route: string;
  children: React.ReactNode;
}

export default function RequireRole({ route, children }: RequireRoleProps) {
  const { canReach, homePath } = useRoles();

  if (!canReach(route)) {
    return <Navigate to={homePath} replace />;
  }

  return <>{children}</>;
}
